import * as mobx from 'mobx';
import { configure } from 'mobx';
import { attachSheet } from './components/theme';

configure({
	enforceActions: 'never',
});
import { initServices, Services } from './services';
import type { BoundWindow } from './services/window.service';
import { initCurrentState, CurrentState } from './state/page.state';
import { AppStore } from './store';

export const IkeOfficeBootstrap = {
	async initBasic($window: BoundWindow) {
		initServices();
		initCurrentState();
		Services.Window.setWindow($window);

		$window.document.addEventListener('DOMContentLoaded', () => {
			attachSheet();

			const waitForGoogleMaps = $window.setInterval(() => {
				if (typeof google === 'undefined') {
					return;
				}
				$window.clearTimeout(waitForGoogleMaps);
				CurrentState.setGoogleMapsLoaded();
			}, 50);
		});

		await Services.bindServices();

		Services.Route.bindRoutes();

		if (!Services.User.hasUser) {
			Services.Route.tokensLoaded = true;
			Services.Route.profilesLoaded = true;
			Services.Route.firstLoad();
		}

		($window as { Ike?: unknown }).Ike = {
			AppStore,
			Services,
			State: CurrentState,
			mobx,
		};
	},

	init($window: BoundWindow) {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		IkeOfficeBootstrap.initBasic($window);
	},
};
